import { Action } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/types/PendingAction';
import { CardOnboardingPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/CardOnboarding/_shared/entities/PaymentMethodDetail/CardOnboardingPaymentMethodDetailEntity';
import { ActionsMap as LoanActionsMap } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/maps/actions.map';

export class ActionsMap {
  static async fromPaymentMethodDetail(
    paymentMethodDetail: CardOnboardingPaymentMethodDetailEntity,
  ): Promise<Action[] | null> {
    if (paymentMethodDetail.isExpired() || paymentMethodDetail.isDeniedOrCancelledOrExpired()) {
      return null;
    }

    const loanActions = await LoanActionsMap.fromPaymentMethodDetail(paymentMethodDetail);
    const isSigned = paymentMethodDetail.isSigned();

    if (!isSigned) {
      return loanActions;
    }

    const baseActions =
      loanActions ??
      ([
        Action.COMPLETE_ONBOARDING,
        Action.UPLOAD_DOCUMENTS,
        ...(paymentMethodDetail.doesRequireKyc() ? [Action.COMPLETE_KYC] : []),
        Action.SIGN_CONTRACT,
      ] as Action[]);

    return [...baseActions, Action.VALIDATE_CARD_DATA, Action.PRINT_CARD];
  }
}
